import { ChangeEvent, Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import splitArray from '../../../../utils/splitArray';
import { MappedReclamationType } from '../../types';

interface UseSearchesI {
  fullReclamations: MappedReclamationType[];
  setReclamationsSplitted: Dispatch<SetStateAction<MappedReclamationType[][]>>;
  setFilteredReclamations: Dispatch<SetStateAction<MappedReclamationType[]>>;
}

export default function useSearches({
  fullReclamations,
  setReclamationsSplitted,
  setFilteredReclamations,
}: UseSearchesI) {
  const [searchTerm, setSearchTerm] = useState('');

  const filterReclamations = useCallback(() => {
    const filteredReclamations = fullReclamations.filter((rcl) => {
      const searchFilter = String(rcl.consultCode).toLowerCase().includes(String(searchTerm).toLowerCase()) || String(rcl.employeeName).toLowerCase().includes(String(searchTerm).toLowerCase());

      return searchFilter;
    });

    const reclamationsSplittedByFilters = splitArray(filteredReclamations);
    setReclamationsSplitted(reclamationsSplittedByFilters);
    setFilteredReclamations(reclamationsSplittedByFilters[0]);
  }, [fullReclamations, searchTerm, setFilteredReclamations, setReclamationsSplitted]);

  useEffect(() => {
    filterReclamations();
  }, [filterReclamations]);

  const handleChangeSearchTerm = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  }, []);

  return {
    searchTerm,
    onChangeSearchTerm: handleChangeSearchTerm,
  };
}
